// extracted by mini-css-extract-plugin
export default {"duration":"VisitDateSelectFields_duration__W+cU6"};